import { request } from '@/fetch/core';
import { HttpStatusCode, Method } from '@/fetch/core/constant';
import { ApiResponse } from '@/types';

const MOCK_DELAY = 500;

// 本地联调用：将列表 mock 成较大数据量以验证表格滚动/渲染性能
const USE_MOCK_PRINCIPAL_LIST = true;
const MOCK_PRINCIPAL_LIST_SIZE = 100;

const mockProvinceList: AccidentProvinceItem[] = [
  { provinceId: 1, provinceName: '北京市' },
  { provinceId: 2, provinceName: '上海市' },
  { provinceId: 3, provinceName: '广东省' },
];

const pad2 = (n: number) => (n < 10 ? `0${n}` : `${n}`);

const formatDateTime = (date: Date) => {
  const y = date.getFullYear();
  const m = pad2(date.getMonth() + 1);
  const d = pad2(date.getDate());
  const hh = pad2(date.getHours());
  const mm = pad2(date.getMinutes());
  const ss = pad2(date.getSeconds());
  return `${y}-${m}-${d} ${hh}:${mm}:${ss}`;
};

function findProvinceName(provinceId: number) {
  return mockProvinceList.find((p) => p.provinceId === provinceId)
    ?.provinceName;
}

const createMockPrincipalList = (size: number): AccidentPrincipalItem[] => {
  const now = Date.now();
  return Array.from({ length: size }).map((_, idx) => {
    const provinceId = idx + 1;
    const provinceName =
      findProvinceName(provinceId) || `模拟省份${provinceId}`;
    const modifyTime = formatDateTime(new Date(now - idx * 60 * 1000));
    return {
      provinceId,
      provinceName,
      erps: `user${provinceId};user${provinceId}_2`,
      modifyTime,
    };
  });
};

let mockPrincipalList: AccidentPrincipalItem[] = createMockPrincipalList(
  MOCK_PRINCIPAL_LIST_SIZE,
);

/**
 * 省份下拉项
 */
export interface AccidentProvinceItem {
  /** 省份id */
  provinceId: number;
  /** 省份名称 */
  provinceName: string;
}

/**
 * 获取省份下拉列表出参
 */
export type GetAccidentProvinceListResponse = AccidentProvinceItem[];

/**
 * 新增/编辑负责人入参
 */
export interface UpsertAccidentPrincipalRequest {
  /** 省份id */
  provinceId: number;
  /** 负责人ERP（多人用英文分号 ; 分隔） */
  erps: string;
}

/**
 * 删除负责人入参
 */
export interface DeleteAccidentPrincipalRequest {
  /** 省份id */
  provinceId: number;
}

/**
 * 列表查询入参
 */
export interface AccidentPrincipalListRequest {
  /** 省份id */
  provinceId?: number | null;
  /** 负责人ERP */
  erp?: string | null;
}

/**
 * 列表数据项
 */
export interface AccidentPrincipalItem {
  /** 省份id */
  provinceId: number;
  /** 省份名称（若后端返回则优先展示） */
  provinceName?: string;
  /** 负责人ERP */
  erps: string;
  /** 更新时间 */
  modifyTime: string;
}

/**
 * 列表查询出参（不分页：直接返回list）
 */
export type AccidentPrincipalListResponse = AccidentPrincipalItem[];

/**
 * 事故进群负责人配置相关接口
 */
class AccidentIntoGroupRuleApi {
  /**
   * 获取省份下拉列表
   */
  public async getProvinceList(): Promise<
    ApiResponse<GetAccidentProvinceListResponse>
  > {
    const requestOptions = {
      path: '/k2/management/accidentPrincipal/get_province_list',
      method: Method.POST,
    };
    // console.log('调用获取省份下拉列表接口, 无入参');
    // return new Promise((resolve) => {
    //   setTimeout(() => {
    //     resolve({
    //       code: HttpStatusCode.Success,
    //       message: 'success',
    //       data: mockProvinceList,
    //     });
    //   }, MOCK_DELAY);
    // });
    return request(requestOptions);
  }

  /**
   * 新增负责人配置
   */
  public async addPrincipal(
    params: UpsertAccidentPrincipalRequest,
  ): Promise<ApiResponse<unknown>> {
    const requestOptions = {
      path: '/k2/management/accidentPrincipal/add',
      method: Method.POST,
      body: params,
    };
    // console.log('调用新增负责人配置接口, 入参:', params);
    // return new Promise((resolve) => {
    //   setTimeout(() => {
    //     const existed = mockPrincipalList.some(
    //       (item) => item.provinceId === params.provinceId,
    //     );

    //     if (existed) {
    //       resolve({
    //         code: HttpStatusCode.ServiceError,
    //         message: '新增失败：该省份已存在配置',
    //         data: null as any,
    //       });
    //       return;
    //     }

    //     mockPrincipalList = [
    //       ...mockPrincipalList,
    //       {
    //         provinceId: params.provinceId,
    //         provinceName: findProvinceName(params.provinceId),
    //         erps: params.erps,
    //         modifyTime: formatDateTime(new Date()),
    //       },
    //     ];

    //     resolve({
    //       code: HttpStatusCode.Success,
    //       message: 'success',
    //       data: null,
    //     });
    //   }, MOCK_DELAY);
    // });
    return request(requestOptions);
  }

  /**
   * 编辑负责人配置
   */
  public async editPrincipal(
    params: UpsertAccidentPrincipalRequest,
  ): Promise<ApiResponse<unknown>> {
    const requestOptions = {
      path: '/k2/management/accidentPrincipal/edit',
      method: Method.POST,
      body: params,
    };
    // console.log('调用编辑负责人配置接口, 入参:', params);
    // return new Promise((resolve) => {
    //   setTimeout(() => {
    //     const targetIndex = mockPrincipalList.findIndex(
    //       (item) => item.provinceId === params.provinceId,
    //     );

    //     if (targetIndex < 0) {
    //       resolve({
    //         code: HttpStatusCode.ServiceError,
    //         message: '编辑失败：未找到该省份配置',
    //         data: null as any,
    //       });
    //       return;
    //     }

    //     const current = mockPrincipalList[targetIndex];
    //     mockPrincipalList = mockPrincipalList.map((item, idx) => {
    //       if (idx !== targetIndex) return item;
    //       return {
    //         ...current,
    //         erps: params.erps,
    //         modifyTime: formatDateTime(new Date()),
    //       };
    //     });

    //     resolve({
    //       code: HttpStatusCode.Success,
    //       message: 'success',
    //       data: null,
    //     });
    //   }, MOCK_DELAY);
    // });
    return request(requestOptions);
  }

  /**
   * 删除负责人配置
   */
  public async deletePrincipal(
    params: DeleteAccidentPrincipalRequest,
  ): Promise<ApiResponse<unknown>> {
    const requestOptions = {
      path: '/k2/management/accidentPrincipal/delete',
      method: Method.POST,
      body: params,
    };
    // console.log('调用删除负责人配置接口, 入参:', params);
    // return new Promise((resolve) => {
    //   setTimeout(() => {
    //     const before = mockPrincipalList.length;
    //     mockPrincipalList = mockPrincipalList.filter(
    //       (item) => item.provinceId !== params.provinceId,
    //     );
    //     const after = mockPrincipalList.length;

    //     if (after === before) {
    //       resolve({
    //         code: HttpStatusCode.ServiceError,
    //         message: '删除失败：未找到该省份配置',
    //         data: null as any,
    //       });
    //       return;
    //     }

    //     resolve({
    //       code: HttpStatusCode.Success,
    //       message: 'success',
    //       data: null,
    //     });
    //   }, MOCK_DELAY);
    // });
    return request(requestOptions);
  }

  /**
   * 查询负责人配置列表
   */
  public async getPrincipalList(
    params: AccidentPrincipalListRequest,
  ): Promise<ApiResponse<AccidentPrincipalListResponse>> {
    const requestOptions = {
      path: '/k2/management/accidentPrincipal/list',
      method: Method.POST,
      body: params,
    };
    // console.log('调用查询负责人配置列表接口, 入参:', params);

    // if (USE_MOCK_PRINCIPAL_LIST) {
    //   return new Promise((resolve) => {
    //     setTimeout(() => {
    //       const provinceId = params?.provinceId ?? null;
    //       const erp = (params?.erp ?? '').toString().trim();

    //       const list = mockPrincipalList.filter((item) => {
    //         if (provinceId && item.provinceId !== provinceId) return false;
    //         if (erp && !(item.erps || '').includes(erp)) return false;
    //         return true;
    //       });

    //       resolve({
    //         code: HttpStatusCode.Success,
    //         message: 'success',
    //         data: list,
    //       });
    //     }, MOCK_DELAY);
    //   });
    // }

    return request(requestOptions);
  }
}

export const accidentIntoGroupRuleApi = new AccidentIntoGroupRuleApi();
